angular.module('mean.trades').controller('TradeFirstBidRequestController', ['$scope', 'MeanUser', 'Global', 'Bids', '$filter', 'Trades', 'Materials', 'Equipments', 'tradeCodeService',
  function($scope, MeanUser, Global, $filter, Trades, Materials, Equipments, tradeCodeService) {
    $scope.global = Global;

    $scope.setMaterialSupplier = function() {
        $scope.my_bid.supplier = $scope.material_supplier;
        $scope.my_bid.$update();
        $scope.getMaterial();
    };

    $scope.setEquipmentSupplier = function() {
        $scope.my_bid.equipment_supplier = $scope.equipment_supplier;
        $scope.my_bid.$update();
        $scope.getEquipment();
    };

    //this is auto called since the user
    //does not have the option to add
    $scope.updateSubtaskValues();

    $scope.closeWindow = function() {
        $scope.my_bid.first_process = false;
        $scope.my_bid.$update();
        this.closeThisDialog();
    };
  }
]);


// WEBPACK FOOTER //
// ./packages/custom/trades/public/controllers/tradeFirstBidRequest.js